<template>
	<div v-if="show" @click.self="dismissModal()" class="fixed pin z-50 overflow-hidden bg-smoke-light flex">
		<div class="relative bg-grey-lightest w-full max-w-xl m-auto flex-col flex rounded m-8 overflow-hidden max-h-screen-90">
			<div class="w-full bg-green-light py-1"></div>
			<div class="flex py-2 m-2 px-4">
				<div class="flex-1 text-left">
					<p class="text-lg font-extrabold" v-text="setting ? 'Redigera inställning' : 'Skapa inställning'"></p>
				</div>
				<div class="flex-1 mr-2">
					<button @click="dismissModal()" class="float-right text-grey hover:text-grey-darker">
						<svg class="fill-current h-5 w-5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>
					</button>
				</div>
			</div>

			<div class="flex ml-6 pb-4">
				<p class="text-sm">
					Vid utskrift kan valet göras att hämta analysnamn från interpolationsinställningen. <br>
					Detta ger flexibilitet då ni kan skräddarsy vad ni vill kalla vissa utskrifter i just er region.<br>
					Fältet <b>namn</b> nedan blir rubriken på utskriften och fältet <b>beskrivning</b> blir rubriken i legenden samt kolumnnamnet i analystabellen.
				</p>
			</div>

			<div class="min-h-screen-35 max-h-screen-80 overflow-y-scroll px-8">
				<div class="w-full flex">
					<div class="w-1/4 px-2">
						<p class="text-left font-semibold mb-2">Namn</p>
						<input :class="[errors.has('title') ? 'border-red focus:border-red' : '', 'input-text mb-1']" type="text" v-model="title">
						<p class="text-sm text-red" v-if="errors.has('title')" v-text="errors.get('title')"></p>
					</div>
					<div class="w-1/2 px-2">
						<p class="text-left font-semibold mb-2">Beskrivning</p>
						<input :class="[errors.has('description') ? 'border-red focus:border-red' : '', 'input-text mb-1']" type="text" v-model="description">
						<p class="text-sm text-red" v-if="errors.has('description')" v-text="errors.get('description')"></p>
					</div>
					<div class="w-1/4 px-2">
						<p class="text-left font-semibold mb-2">Typ</p>
						<div class="relative">
							<select v-model="type" :class="[errors.has('type') ? 'border-red focus:border-red' : '','block appearance-none w-full bg-white border border-grey-light hover:border-grey px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline mb-1']">
								<option v-for="type in types" :key="type.slug" :value="type.slug" v-text="type.title"></option>
							</select>
							<div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
								<svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
							</div>
						</div>
						<p class="text-sm text-red" v-if="errors.has('type')" v-text="errors.get('type')"></p>
					</div>
				</div>

				<div class="w-full flex mt-5">

					<div class="w-1/4 px-2">
						<p class="text-left font-semibold mb-2">Interpoleringsalgoritm</p>
						<div class="relative">
							<select v-model="interpolation_type" :class="[errors.has('interpolation_type') ? 'border-red focus:border-red' : '','block appearance-none w-full bg-white border border-grey-light hover:border-grey px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline mb-1']">
								<option :value="1">Traditionell</option>
								<option :value="3">Ny interpolationsteknik</option>
							</select>
							<div class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
								<svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
							</div>
						</div>
						<p class="text-sm text-red" v-if="errors.has('interpolation_type')" v-text="errors.get('interpolation_type')"></p>
					</div>

					<div class="w-1/4 px-2">
						<p class="text-left font-semibold mb-2">Sökradie</p>
						<input :class="[errors.has('search_radius') ? 'border-red focus:border-red' : '', 'input-text mb-1']" type="number" v-model="search_radius">
						<p class="text-sm text-red" v-if="errors.has('search_radius')" v-text="errors.get('search_radius')"></p>
					</div>

					<div class="w-1/4 px-2">
						<p class="text-left font-semibold mb-2">Maskradie</p>
						<input :class="[errors.has('mask_radius') ? 'border-red focus:border-red' : '', 'input-text mb-1']" type="number" v-model="mask_radius">
						<p class="text-sm text-red" v-if="errors.has('mask_radius')" v-text="errors.get('mask_radius')"></p>
						<small>
							Ändras endast om det är färre än 1 prov/ha. Standard: 100
						</small>
					</div>

					<div class="w-1/4 px-2">
						<p class="text-left font-semibold mb-2">Interpolationsfaktor</p>
						<input :class="[errors.has('interpolation_factor') ? 'border-red focus:border-red' : '', 'input-text mb-1']" type="number" v-model="interpolation_factor">
						<p class="text-sm text-red" v-if="errors.has('interpolation_factor')" v-text="errors.get('interpolation_factor')"></p>
					</div>
				</div>

				<div class="w-full flex mt-5">
					<div class="w-1/6 px-2">
						<div v-if="setting && setting.active" class="mb-2">
							<svg class="w-4 h-4 pt-1 text-green fill-current" viewBox="0 0 24 24"><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/></svg>
							<span class="text-sm ml-2">Aktiv</span>
						</div>
						<label v-else class="checkbox-container">
							<input type="checkbox" v-model="active" >
							<span class="checkmark"></span>
							<span class="checkmark-text">Aktiv</span>
						</label>
						<p class="text-xs" v-if="setting && setting.active">Du kan inte avmarkera en aktiv inställning</p>
					</div>

					<div class="w-1/4 px-2">
						<label class="checkbox-container">
							<input type="checkbox" v-model="smooth_colors" >
							<span class="checkmark"></span>
							<span class="checkmark-text">Mjuka färgövergångar</span>
						</label>
					</div>

					<div class="w-1/4 px-2">
						<label class="checkbox-container">
							<input type="checkbox" v-model="interpolate_over_borders" >
							<span class="checkmark"></span>
							<span class="checkmark-text">Interpolera över fältgränser</span>
						</label>
					</div>

					<div class="w-1/4 px-2">
						<label class="checkbox-container">
							<input type="checkbox" v-model="interpolate_zero_values" >
							<span class="checkmark"></span>
							<span class="checkmark-text">Interpolera nollvärden</span>
						</label>
					</div>
				</div>

				<div class="w-full mt-3 pt-4 border-t">
					<div class="w-full flex">
						<div class="w-1/4 px-2">
							<p :class="[errors.has('colors') ? 'text-red' : '','text-3xl font-thin']">Färger</p>
							<p class="text-red text-sm mt-1" v-if="errors.has('colors')" v-text="errors.get('colors')"></p>
						</div>
						<div class="w-3/4 px-2">
							<div v-if="addingColor" class="w-full flex">
								<div class="w-1/4 px-2">
									<p class="text-left mb-2">Min</p>
									<input :class="[fromInvalid ? 'border-red focus:border-red' : '', 'input-text mb-1']" type="number" v-model="from">
									<p class="text-sm text-red" v-if="fromInvalid">Min finns med i ett annat intervall</p>
								</div>
								<div class="w-1/4 px-2">
									<p class="text-left mb-2">Max</p>
									<input :class="[toInvalid ? 'border-red focus:border-red' : '', 'input-text mb-1']" type="number" v-model="to">
									<p v-if="toInvalid"  class="text-sm text-red">Max finns med i ett annat intervall</p>
									<p v-else-if="fromGreaterThanTo" class="text-sm text-red">Max måste var större än min</p>
								</div>
								<div class="w-1/4 px-2">
									<p class="text-left mb-2">Färg</p>
									<input class="input-text" style="height: 2.37rem;" type="color" v-model="hexcolor">
								</div>
								<div class="w-1/4 pl-5 pt-6">
									<button @click="addColor()" :disabled="!canSaveColor" class="button px-3 no-outline text-grey-darkest border hover:bg-grey-light shadow">
										<svg class="w-3 h-3 text-green fill-current" viewBox="0 0 24 24"><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/></svg>
									</button>
									<button @click="setAddingColor(false)" class="button px-3 ml-1 no-outline text-grey-darkest border hover:bg-grey-light shadow">
										<svg class="w-3 h-3 text-red fill-current" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>
									</button>
								</div>
							</div>
							<button v-else-if="canAddColors" class="button no-outline text-white font-semibold bg-green hover:bg-green-dark shadow float-right" @click="setAddingColor(true)"><i class="fa fa-plus"></i> Lägg till ny färg</button>
						</div>
					</div>

					<div class="rounded-lg border overflow-hidden mt-5 mx-1" v-if="colors.length && canAddColors">
						<table class="table table-scrollable-50 mb-0 w-full">
							<thead>
								<tr>
									<th>Min</th>
									<th>Max</th>
									<th>Färg</th>
									<th></th>
								</tr>
							</thead>
							<tbody class="max-h-screen-40">
								<tr v-for="color in sortedSpans" :key="color.id">
									<td v-if="editingColor_id === color.id">
										<input :class="[fromInvalid ? 'border-red focus:border-red' : '', 'input-text mb-1']" type="number" v-model="from">
										<p class="text-sm text-red" v-if="fromInvalid">Min finns med i ett annat intervall</p>
									</td>
									<td v-if="editingColor_id === color.id">
										<input :class="[toInvalid ? 'border-red focus:border-red' : '', 'input-text mb-1']" type="number" v-model="to">
										<p v-if="toInvalid"  class="text-sm text-red">Max finns med i ett annat intervall</p>
										<p v-else-if="fromGreaterThanTo" class="text-sm text-red">Max måste var större än min</p>
									</td>
									<td v-if="editingColor_id === color.id">
										<input class="input-text w-1/2 mt-2" style="height: 2.37rem;" type="color" v-model="hexcolor">
									</td>
									<td v-if="editingColor_id === color.id">
										<div class="btn-group">
											<button @click="updateColor(color)" class="button-sm px-3 py-2 no-outline text-grey-darkest border hover:bg-grey-light shadow">
												<svg class="w-3 h-3 text-green fill-current" viewBox="0 0 24 24"><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/></svg>
											</button>
											<button @click="editColor()" class="button-sm px-3 py-2 ml-1 no-outline text-grey-darkest border hover:bg-grey-light shadow">
												<svg class="w-3 h-3 text-red fill-current" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>
											</button>
										</div>
									</td>

									<td v-if="editingColor_id !== color.id" v-text="color.from">></td>
									<td v-if="editingColor_id !== color.id" v-text="color.to">></td>
									<td v-if="editingColor_id !== color.id"><div class="w-6 h-2 rounded-full" :style="'background-color:' + getRgb(color) +';'"></div></td>
									<td v-if="editingColor_id !== color.id">
										<button @click="editColor(color)" class="button-sm px-3 no-outline text-grey-darkest border hover:bg-grey-light shadow">
											<svg class="w-4 h-4 text-green fill-current" viewBox="0 0 24 24"><path d="M7.127 22.564l-7.126 1.436 1.438-7.125 5.688 5.689zm-4.274-7.104l5.688 5.689 15.46-15.46-5.689-5.689-15.459 15.46z"/></svg>
										</button>
										<button @click="removeColor(color)" class="button-sm px-3 ml-1 no-outline text-grey-darkest border hover:bg-grey-light shadow">
											<svg class="w-3 h-3 mt-1 text-red fill-current" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>
										</button>
									</td>
								</tr>
								<tr v-if="lastSpan">
									<td v-text="lastSpan.from + '+'" colspan="2"></td>
									<td v-if="editingColor_id !== 'lastspan'"><div class="w-6 h-2 rounded-full" :style="'background-color:' + getRgb(lastSpan.color) +';'"></div></td>
									<td v-if="editingColor_id !== 'lastspan'">
										<button @click="editColor('lastspan')" class="button-sm px-3 no-outline text-grey-darkest border hover:bg-grey-light shadow">
											<svg class="w-4 h-4 text-green fill-current" viewBox="0 0 24 24"><path d="M7.127 22.564l-7.126 1.436 1.438-7.125 5.688 5.689zm-4.274-7.104l5.688 5.689 15.46-15.46-5.689-5.689-15.459 15.46z"/></svg>
										</button>
									</td>

									<td v-if="editingColor_id === 'lastspan'">
										<input class="input-text w-1/2 mt-2" style="height: 2.37rem;" type="color" v-model="hexcolor">
									</td>
									<td v-if="editingColor_id === 'lastspan'">
										<button @click="updateColor('lastspan')" class="button-sm px-3 py-2 no-outline text-grey-darkest border hover:bg-grey-light shadow">
											<svg class="w-3 h-3 text-green fill-current" viewBox="0 0 24 24"><path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"/></svg>
										</button>
										<button @click="editColor()" class="button-sm px-3 py-2 ml-1 no-outline text-grey-darkest border hover:bg-grey-light shadow">
											<svg class="w-3 h-3 text-red fill-current" viewBox="0 0 24 24"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"/></svg>
										</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<p class="ml-2 mt-3" v-else-if="!canAddColors">Denna inställningens färger kan inte redigeras då det är en grundinställning.</p>
				</div>



			</div>
			<div class="w-full bg-grey-lightish py-4 mt-5 px-8 flex justify-end">
				<button @click="save()" class="items-center w-auto py-2 px-2 pr-2 text-sm text-center text-white block bg-green hover:bg-green-dark rounded shadow-light font-bold">Spara</button>
			</div>

		</div>
	</div>
</template>

<script>

require('@/utils/form.js')

import axios from 'axios';
import uuid from 'uuid';

import { mapGetters } from 'vuex'

export default {

    data() {
        return {
			show: false,
			setting: null,

			title: null,
			description: null,
			type: null,
			interpolation_type: 1,
			smooth_colors: false,
			search_radius: 80,
			mask_radius: 100,
			interpolation_factor: 2,
			interpolate_over_borders: false,
			interpolate_zero_values: false,
			active: false,

			colors: [],
			from: null,
			to: null,
			hexcolor: '#5dd045',
			editingColor_id: null,
			addingColor: null,
			finalColor: {
				r: 0,
				g: 0,
				b: 0,
			},

			errors: new FormErrors(),
        }
    },

	mounted() {
		bus.$on('open-interpolation-setting-modal', this.showModal)
		bus.$on('close-interpolation-setting-modal', this.dismissModal)
	},

    beforeDestroy() {
        bus.$off('open-interpolation-setting-modal')
        bus.$off('close-interpolation-setting-modal')
    },

	computed: {
		...mapGetters({
			types: 'analysis/types',
		}),

		isDefault() {
			return this.setting !== null && this.setting.default
		},

		canAddColors() {
			return !this.isDefault || this.setting.interpolation_colors.length === 0
		},

		/**
		 * Returns all the colors sorted
		 */
		sortedSpans() {
			return this.colors.sort((a,b) => a.from - b.from)
		},

		/**
		 * Returns true if the from value would overlap
		 * another span (except itself if a color is being edited)
		 */
		fromInvalid() {
			if(this.from === null || this.from === '') {
				return false
			}
			return this.sortedSpans.filter(color => {
				return color.id !== this.editingColor_id
			}).some(color => {
				return parseFloat(this.from) >= parseFloat(color.from) && parseFloat(this.from) < parseFloat(color.to)
			})
		},
		
		/**
		 * Returns true if the to value would overlap
		 * another span (except itself if a color is being edited)
		 */
		toInvalid() {
			if(this.to === null || this.to === '') {
				return false
			}
			return this.sortedSpans.filter(color => {
				return color.id !== this.editingColor_id
			}).some(color => {
				return parseFloat(this.to) > parseFloat(color.from) && parseFloat(this.to) <= parseFloat(color.to)
			})
		},

		fromGreaterThanTo() {
			return parseFloat(this.from) >= parseFloat(this.to)
		},

		canSaveColor() {
			return !this.fromInvalid && !this.toInvalid && !this.fromGreaterThanTo && this.from && this.to
		},

		/**
		 * Returns a colorObject that is always greater than the
		 * largest value entered by the user
		 */
		lastSpan() {
			if(this.colors.length) {
				return {
					from: this.sortedSpans[this.sortedSpans.length - 1].to,
					color: this.finalColor
				}
			}
			return null
		}
	},

	methods: {
		showModal(setting) {
			if(setting) {
				this.fillValues(setting)
			}
			this.show = true
		},

		dismissModal() {
			// TODO: Lägg till en confirm här! om man verkligen vill stänga.
			this.show = false
			this.closed()
		},

		/**
		 * Will add a color to the array of colors
		 */
		addColor() {
			let rgb = this.hexToRgb(this.hexcolor)

			this.colors.push({
				id: uuid.v4(),
				from: this.from,
				to: this.to,
				r: rgb.r,
				g: rgb.g,
				b: rgb.b,
				a: 0,
			})
			this.setAddingColor(false)
		},
		
		/**
		 * If a color is provided this function will th editingColor_id to 
		 * the colors id and will set the fields to the colors properties
		 * If there is no color all fields will be reset
		 */
		editColor(color) {
			if(color === 'lastspan') {
				this.editingColor_id = 'lastspan'
				this.hexcolor = this.rgbToHex(this.finalColor.r, this.finalColor.g, this.finalColor.b)
			} else if(color) {
				this.addingColor = false

				this.from = color.from
				this.to = color.to
				this.hexcolor = this.rgbToHex(color.r, color.g, color.b)
				this.editingColor_id = color.id
			} else {
				this.from = null
				this.to = null
				this.hexcolor = null
				this.editingColor_id = null
			}
		},

		/**
		 * Will update the provided color with
		 * new properties
		 */
		updateColor(color) {
			let rgb = this.hexToRgb(this.hexcolor)

			if(color === 'lastspan') {
				this.finalColor.r = rgb.r
				this.finalColor.g = rgb.g
				this.finalColor.b = rgb.b
			} else {
				color.from = this.from
				color.to = this.to
				color.r = rgb.r
				color.g = rgb.g
				color.b = rgb.b
			}

			this.editingColor_id = null
		},

		removeColor(color) {
			this.colors = this.colors.filter(c => c.id != color.id)
		},

		/**
		 * Will reset the fields needed to add a color and will 
		 * show the fields
		 */
		setAddingColor(state) {
			if(this.sortedSpans && this.sortedSpans.length) {
				this.from = this.sortedSpans[this.sortedSpans.length - 1].to
			} else {
				this.from = null
			}
			this.to = null
			this.hexcolor = '#5dd045'

			this.addingColor = state
			if(state) {
				this.editingColor_id = null
			}
		},

		/**
		 * Will save/update the setting
		 */
		save() {

			let colors = this.sortedSpans

			// Add the last colour
			if(this.colors.length) {
				// Calculate how much the to value should be increased wit
				let meanDiff = this.sortedSpans.reduce((sum, span) => {
					return sum += (span.to - span.from)
				}, 0) / this.sortedSpans.length

				colors.push({
					from: this.lastSpan.from,
					to: Math.round((parseInt(this.lastSpan.from) + meanDiff) * 100) / 100,
					r: this.finalColor.r,
					g: this.finalColor.g,
					b: this.finalColor.b,
					a: 0,
				})
			}

			let params = {
				title:						this.title,
				description:				this.description,
				type:						this.type,
				interpolation_type:			this.interpolation_type,
				smooth_colors:				this.smooth_colors,
				search_radius:				this.search_radius,
				mask_radius:				this.mask_radius,
				interpolation_factor:		this.interpolation_factor,
				interpolate_over_borders:	this.interpolate_over_borders,
				interpolate_zero_values:	this.interpolate_zero_values,
				active:						this.active,
				colors:						this.colors,
			}

			if(this.setting) {
				axios.patch('/interpolationsetting/' + this.setting.id, params)
				.then(response => {
					this.$store.dispatch("interpolationSettings/UPDATE_SETTING", response.data)
					this.errors.forget()

					bus.$emit('show-notification', "Inställningen uppdaterades!")
					this.dismissModal()
				})
				.catch(resp => {
					this.errors.set(resp.response.data.errors);
				})
			} else {
				axios.post('/interpolationsetting', params)
				.then(response => {
					this.$store.dispatch("interpolationSettings/ADD_SETTING", response.data)
					this.errors.forget()

					bus.$emit('show-notification', "Inställningen har lagts till!")
					this.dismissModal()
				})
				.catch(resp => {
					this.errors.set(resp.response.data.errors);
				})
			}
		},

		/**
		 * Creates an rgb-string from the color-object
		 */
		getRgb(color) {
			return "rgb(" + color.r + ',' + color.g + ',' + color.b + ')'
		},

		/**
		 * Converts rgb to a hex color string
		 */
		rgbToHex(r, g, b) {
  			return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
		},

		/**
		 * Converts a hex color string to rgb
		 */
		hexToRgb(hex) {
			var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			return result ? {
				r: parseInt(result[1], 16),
				g: parseInt(result[2], 16),
				b: parseInt(result[3], 16)
			} : null
		},

		/**
		 * Will copy the setting and its properites and fill fields with them
		 */
		fillValues(setting) {
			this.setting =					setting
			this.title =					this.setting.title
			this.description =				this.setting.description
			this.type =						this.setting.type
			this.interpolation_type =		this.setting.interpolation_type
			this.smooth_colors =			this.setting.smooth_colors
			this.search_radius =			this.setting.search_radius
			this.mask_radius =				this.setting.mask_radius
			this.interpolation_factor =		this.setting.interpolation_factor
			this.interpolate_over_borders =	this.setting.interpolate_over_borders
			this.interpolate_zero_values =	this.setting.interpolate_zero_values
			this.active =					this.setting.active

			// Copy all the colors except the last one. Since it will be computed
			this.colors =					JSON.parse(JSON.stringify(this.setting.interpolation_colors.slice(0, this.setting.interpolation_colors.length - 1)))
			if(this.setting.interpolation_colors.length) {
				this.finalColor =				{
					r: this.setting.interpolation_colors[this.setting.interpolation_colors.length - 1].r,
					b: this.setting.interpolation_colors[this.setting.interpolation_colors.length - 1].b,
					g: this.setting.interpolation_colors[this.setting.interpolation_colors.length - 1].g
				}
			} else {
				this.finalColor = {r: 0, b: 0, g: 0}
			}
		},

		/**
		 * Clears all fields/values when modal is closed
		 */
		closed() {
			this.setting = 					null
			this.title =					null
			this.description =				null
			this.type =						null
			this.interpolation_type =		1
			this.smooth_colors =			false
			this.search_radius =			80
			this.mask_radius =				100
			this.interpolation_factor =		2
			this.interpolate_over_borders =	false
			this.interpolate_zero_values =	false
			this.active =					false
			this.colors =					[]
			this.finalColor = 				{r: 0, g: 0, b: 0}
			this.from = 					null
			this.to = 						null
			this.hexcolor =					'#5dd045'
			this.errors.forget()
		},
	}

}
</script>